module.exports = __webpack_public_path__ + "static/discover-65cadcd075bbbdd32771e4266eeba895.svg";